import React from "react";
import { PaddingBox, Icon } from "./styles";
import facebook from "../../assets/facebook-symbol.svg";
import twitter from "../../assets/twitter-symbol.svg";
import linkedin from "../../assets/linkedin-symbol.svg";
import instagram from "../../assets/instagram-symbol.svg";
export const SocialIcons = () => (
  <React.Fragment>
    <PaddingBox
      href="https://www.facebook.com/SunWestMortgage/"
      target="_blank"
    >
      <Icon src={facebook} />
    </PaddingBox>
    <PaddingBox
      href="https://www.instagram.com/sunwestmortgage.inc/"
      target="_blank"
    >
      <Icon src={instagram} />
    </PaddingBox>
    <PaddingBox href="https://twitter.com/SunWestMortgage" target="_blank">
      <Icon src={twitter} />
    </PaddingBox>
    <PaddingBox
      href="https://www.linkedin.com/company/sun-west-mortgage-company"
      target="_blank"
    >
      <Icon src={linkedin} />
    </PaddingBox>
  </React.Fragment>
);
